import {
  GET_MYSHIFTS_FAIL,
  GET_MYSHIFTS_SUCCESS,
  UPDATE_MYSHIFTS_BEGIN_DATE,
  UPDATE_MYSHIFTS_END_DATE,
} from '../actions/actionTypes';
import { logout } from '../actions';

const today = new Date();
const twoWeeksAgo = new Date(Date.now() - 11005e5);
const myShifts = (
  state = { beginDate: twoWeeksAgo, endDate: today, shifts: [] },
  action,
) => {
  switch (action.type) {
    case UPDATE_MYSHIFTS_BEGIN_DATE:
      return {
        ...state,
        beginDate: action.payload,
      };
    case UPDATE_MYSHIFTS_END_DATE:
      return {
        ...state,
        endDate: action.payload,
      };
    case GET_MYSHIFTS_SUCCESS:
      action.payload.sort((a, b) => {
        var keyA = new Date(a.Date),
          keyB = new Date(b.Date);
        // Compare the 2 dates
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      return {
        ...state,
        shifts: action.payload,
      };
    case GET_MYSHIFTS_FAIL:
      if (action.payload.status === 401) {
        logout();
      }
      return state;
    default:
      return state;
  }
};

export default myShifts;
